import React from 'react'
import styles from './Controls.module.scss'

interface ContainerProps {
  onGuess: () => void
  currentGuess: string | undefined
}

const Container: React.FC<ContainerProps> = (props) => {
  return (
    <div className={styles.container}>
      <p>
        Current guess: <span>{props.currentGuess}</span>
      </p>
      {props.currentGuess && <button onClick={props.onGuess}>Guess</button>}
      {!props.currentGuess && (
        <button disabled className="disabledButton">
          Place a pin
        </button>
      )}
    </div>
  )
}

export default Container
